<template>
  <div class="container-fluid">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir xifres anuals" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-any">Any</label>
                <div class="input-group w-50">
                  <input ref="autofocusCreacion" type="number" class="form-control" id="nuevo-any" v-model="nuevos.anual.any" :disabled="loading.creacion" min="2010" :max="anyoMax" />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-comercial">Marge comercial</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-comercial" v-model="nuevos.anual.comercial" :disabled="loading.creacion" min="0" max="100" required />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-coordinacion">Marge coordinació</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-coordinacion" v-model="nuevos.anual.coordinacion" :disabled="loading.creacion" min="0" max="100" required />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-indirectos">Marge indirectes</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-indirectos" v-model="nuevos.anual.indirectos" :disabled="loading.creacion" min="0" max="100" required />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-tecnico_especialista">Cost TÈCNIC ESPECIALISTA</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-tecnico_especialista" v-model="nuevos.anual['TÈCNIC ESPECIALISTA']" :disabled="loading.creacion" min="0" max="999.99" required />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-tecnico_generalista">Cost TÈCNIC GENERALISTA</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-tecnico_generalista" v-model="nuevos.anual['TÈCNIC GENERALISTA']" :disabled="loading.creacion" min="0" max="999.99" required />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-ADMIN_EDUCADOR">Cost ADMIN_EDUCADOR</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-ADMIN_EDUCADOR" v-model="nuevos.anual.ADMIN_EDUCADOR" :disabled="loading.creacion" min="0" max="999.99" required />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-OPERARI">Cost OPERARI</label>
                <div class="input-group w-50">
                  <input type="number" step="0.01" class="form-control text-right" id="nuevo-OPERARI" v-model="nuevos.anual.OPERARI" :disabled="loading.creacion" min="0" max="999.99" required />
                  <div class="input-group-append">
                    <span class="input-group-text">€</span>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion"><i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar</button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap xifres anuals</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar xifres anuals" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar xifres anuals" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar xifres anuals" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="form-group">
                  <label :for="`any${props.row.id}`">Any</label>
                  <div class="input-group w-50">
                    <input type="number" class="form-control" :id="`any${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).any" :disabled="loading.edicion" min="2010" :max="anyoMax" />
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`comercial${props.row.id}`">Marge comercial</label>
                  <div class="input-group w-50">
                    <input :ref="`autofocusEdicion${props.row.id}`" type="number" step="0.01" class="form-control text-right" :id="`comercial${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).comercial" :disabled="loading.edicion" min="0" max="100" required />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`coordinacion${props.row.id}`">Marge coordinació</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`coordinacion${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).coordinacion" :disabled="loading.edicion" min="0" max="100" required />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`indirectos${props.row.id}`">Marge indirectes</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`indirectos${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).indirectos" :disabled="loading.edicion" min="0" max="100" required />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`tecnico_especialista${props.row.id}`">Cost TÈCNIC ESPECIALISTA</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`tecnico_especialista${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer)['TÈCNIC ESPECIALISTA']" :disabled="loading.edicion" min="0" max="999.99" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`tecnico_generalista${props.row.id}`">Cost TÈCNIC GENERALISTA</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`tecnico_generalista${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer)['TÈCNIC GENERALISTA']" :disabled="loading.edicion" min="0" max="999.99" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`ADMIN_EDUCADOR${props.row.id}`">Cost ADMIN_EDUCADOR</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`ADMIN_EDUCADOR${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).ADMIN_EDUCADOR" :disabled="loading.edicion" min="0" max="999.99" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="`OPERARI${props.row.id}`">Cost OPERARI</label>
                  <div class="input-group w-50">
                    <input type="number" step="0.01" class="form-control text-right" :id="`OPERARI${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).OPERARI" :disabled="loading.edicion" min="0" max="999.99" required />
                    <div class="input-group-append">
                      <span class="input-group-text">€</span>
                    </div>
                  </div>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar xifres anuals" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar les xifres de <b>{{ props.row.any }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="comercial" slot-scope="props">{{ formatearDecimales(props.cell_value) }}%</template>
      <template slot="coordinacion" slot-scope="props">{{ formatearDecimales(props.cell_value) }}%</template>
      <template slot="indirectos" slot-scope="props">{{ formatearDecimales(props.cell_value) }}%</template>
      <template slot="TÈCNIC ESPECIALISTA" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
      <template slot="TÈCNIC GENERALISTA" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
      <template slot="ADMIN_EDUCADOR" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
      <template slot="OPERARI" slot-scope="props">{{ formatearDecimales(props.cell_value) }}€</template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "XifresAnuals",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "actionsExportar"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Any",
          name: "any",
          filter: {
            type: "simple",
            placeholder: "Filtra any",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-center",
        },
        {
          label: "Marge comercial",
          name: "comercial",
          filter: {
            type: "simple",
            placeholder: "Filtra marge comercial",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Marge coordinació",
          name: "coordinacion",
          filter: {
            type: "simple",
            placeholder: "Filtra coordinació",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Marge indirectes",
          name: "indirectos",
          filter: {
            type: "simple",
            placeholder: "Filtra marge indirectes",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Cost TÈCNIC ESPECIALISTA",
          name: "TÈCNIC ESPECIALISTA",
          filter: {
            type: "simple",
            placeholder: "Filtra cost TÈCNIC ESPECIALISTA",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Cost TÈCNIC GENERALISTA",
          name: "TÈCNIC GENERALISTA",
          filter: {
            type: "simple",
            placeholder: "Filtra cost TÈCNIC GENERALISTA",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Cost ADMIN_EDUCADOR",
          name: "ADMIN_EDUCADOR",
          filter: {
            type: "simple",
            placeholder: "Filtra cost ADMIN_EDUCADOR",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Cost OPERARI",
          name: "OPERARI",
          filter: {
            type: "simple",
            placeholder: "Filtra cost OPERARI",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Totes les xifres anuals",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        anual: {
          any: null,
          comercial: null,
          coordinacion: null,
          indirectos: null,
          OPERARI: null,
          ADMIN_EDUCADOR: null,
          "TÈCNIC GENERALISTA": null,
          "TÈCNIC ESPECIALISTA": null,
        },
      },
    };
  },
  computed: {
    anyoMax: function () {
      return new Date().getFullYear() + 1;
    },
  },
  methods: {
    getData: function () {
      this.$http.get("api/anuals").then((response) => {
        this.rows = response.data;
      });
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/anuals", this.nuevos.anual)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(function () {
            if (response.status == 201) {
              this.rows.push(response.data);

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres anuals creades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/anuals/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(function () {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres anuals editades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/anuals/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Xifres anuals eliminades correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion: function () {
      this.nuevos.anual.any = null;
      this.nuevos.anual.comercial = null;
      this.nuevos.anual.coordinacion = null;
      this.nuevos.anual.indirectos = null;
      this.nuevos.anual.OPERARI = null;
      this.nuevos.anual.ADMIN_EDUCADOR = null;
      this.nuevos.anual["TÈCNIC GENERALISTA"] = null;
      this.nuevos.anual["TÈCNIC ESPECIALISTA"] = null;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>